import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import FieldsCollection from "../../../../components/FieldsCollection/FieldsCollection";
import QuestionField from "../QuestionField/QuestionField";
import Select from "../../../../components/Select/Select";

export default class PepQuestions extends React.Component
{
    state = {
        appliesToUbo: this.props.appliesToUbo,

        fields: {
            radio_customer_pep: {
                options: [
                    {label: "Nej", value: "no", checked: false},
                    {label: "Ja", value: "yes", checked: false}
                ]
            },

            radio_customer_pep_past: {
                options: [
                    {label: "Nej", value: "no", checked: false},
                    {label: "Ja", value: "yes", checked: false}
                ]
            },

            radio_customer_pep_details: {
                index: -1,
                name: "radio_customer_pep_details",
                options: [
                    {
                        label: "Statschefen",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Riksdagsledamöter",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Statsministern och övriga ministrar i regeringskansliet",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Domare i Högsta domstolen och Högsta förvaltningsdomstolen",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Riksrevisorerna",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Riksbankens direktion",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Ambassadörer",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Höga officerare (general, generallöjtnant, generalmajor, amiral, viceamiral och konteramiral)",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Vd eller styrelseledamot i statsägda företag",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Person i ledningen i en internationell organisation (styrelseledamöter, generalsekreterare med flera)",
                        name: "radio_customer_pep_details"
                    },
                    {
                        label: "Ledamot i politiskt partis styrelse",
                        name: "radio_customer_pep_details"
                    }
                ]
            },

            radio_customer_pep_past_details: {
                index: -1,
                name: "radio_customer_pep_past_details",
                options: [
                    {
                        label: "Statschefen",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Riksdagsledamöter",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Statsministern och övriga ministrar i regeringskansliet",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Domare i Högsta domstolen och Högsta förvaltningsdomstolen",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Riksrevisorerna",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Riksbankens direktion",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Ambassadörer",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Höga officerare (general, generallöjtnant, generalmajor, amiral, viceamiral och konteramiral)",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Vd eller styrelseledamot i statsägda företag",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Person i ledningen i en internationell organisation (styrelseledamöter, generalsekreterare med flera)",
                        name: "radio_customer_pep_past_details"
                    },
                    {
                        label: "Ledamot i politiskt partis styrelse",
                        name: "radio_customer_pep_past_details"
                    }
                ]
            },

            pep_info: "",
            pep_info_relative: ""
        }
    };

    render()
    {
        const {state} = this;

        return (
            <React.Fragment>
                <h3 style={{margin: "40px 0 0 0"}}>PEP - Politiskt exponerad person</h3>

                <div className="description">
                    <p>
                        PEP – Person i politiskt utsatt ställning – Person som har eller tidigare har haft en hög
                        politisk post, en hög statlig befattning eller funktion i ledningen i en internationell
                        organisation, eller har en nära familjemedlem eller medarbetare med ovanstående befattning.
                    </p>
                </div>

                <FieldsCollection
                    fields={[
                        {
                            render: (
                                <OptionsList
                                    type="radio"
                                    orientation="horizontal"
                                    name="radio_customer_pep"
                                    description={state.appliesToUbo ?
                                        "Är någon av huvudmännen en person i politiskt utsatt ställning, närstående eller medarbetare till en sådan person?" :
                                        "Är du själv, eller har du varit, en politiskt exponerad person/politiskt utsatt person?"}
                                    options={state.fields.radio_customer_pep.options}
                                    onChange={this._onOptionsListChange}
                                />
                            )
                        }
                    ]}
                />

                {state.fields.radio_customer_pep.options[1].checked && (
                    <div style={{margin: "10px 0 0 0", display: "block", width: "100%"}}>
                        <QuestionField
                            Component={Select}
                            description={state.appliesToUbo ? "Vilken typ av PEP är huvudman?" : "Vilken typ av PEP är du?"}
                            label="Välj"
                            name={state.fields.radio_customer_pep_details.name}
                            selectedIndex={state.fields.radio_customer_pep_details.index}
                            options={state.fields.radio_customer_pep_details.options}
                            onChange={this._onSelectPepChange}
                        />
                    </div>
                )}

                {state.fields.radio_customer_pep.options[1].checked && state.fields.radio_customer_pep_details.index !== -1 && (
                    <input type="hidden" name="pep_info" value={state.fields.radio_customer_pep_details.options[state.fields.radio_customer_pep_details.index].label} />
                )}

                <FieldsCollection
                    fields={[
                        {
                            render: (
                                <OptionsList
                                    type="radio"
                                    orientation="horizontal"
                                    style={{margin: "10px 0 0 0"}}
                                    name="radio_customer_pep_past"
                                    description={state.appliesToUbo ?
                                        "Har någon av ovanstående personer varit en person i politiskt utsatt ställning, närstående eller medarbetare till en sådan person?" :
                                        "Har du någon närstående som är, eller har varit, en politiskt exponerad person/politiskt utsatt person?"}
                                    options={state.fields.radio_customer_pep_past.options}
                                    onChange={this._onOptionsListChange}
                                />
                            )
                        }
                    ]}
                />

                {state.fields.radio_customer_pep_past.options[1].checked && (
                    <div style={{margin: "10px 0 0 0", display: "block", width: "100%"}}>
                        <QuestionField
                            Component={Select}
                            description={state.appliesToUbo ? "Vilken typ av PEP har huvudman varit?" : "Vilken typ av PEP är din närstående?"}
                            label="Välj"
                            name={state.fields.radio_customer_pep_past_details.name}
                            selectedIndex={state.fields.radio_customer_pep_past_details.index}
                            options={state.fields.radio_customer_pep_past_details.options}
                            onChange={this._onSelectPepChange}
                        />
                    </div>
                )}

                {state.fields.radio_customer_pep_past.options[1].checked && state.fields.radio_customer_pep_past_details.index !== -1 && (
                    <input type="hidden" name="pep_info_relative" value={state.fields.radio_customer_pep_past_details.options[state.fields.radio_customer_pep_past_details.index].label} />
                )}
            </React.Fragment>
        );
    }

    _onOptionsListChange = ({type, name}, option, index) =>
    {
        const newOptions = [...this.state.fields[name].options].map((o, i) =>
        {
            if (i === index)
            {
                return option;
            }

            return {...o, checked: type === "radio" ? false : o.checked};
        });

        this.setState({fields: {...this.state.fields, [name]: {options: newOptions}}}, () => {
            if (this.props.onUpdate)
            {
                this.props.onUpdate(this._isPepFulfilled());
            }
        });
    };

    _onSelectPepChange = (option, index) => {
        this.setState({
            fields: {...this.state.fields,
                [option.name]: {...this.state.fields[option.name], index: index,},
                [option.name + "_value"]: option.label
            },
        }, () => {
            if (this.props.onUpdate)
            {
                this.props.onUpdate(this._isPepFulfilled());
            }
        });
    };

    _isPepFulfilled = () =>
    {
        if (!this.state.fields.radio_customer_pep.options[0].checked &&
            !this.state.fields.radio_customer_pep.options[1].checked)
        {
            return false;
        }

        if (!this.state.fields.radio_customer_pep_past.options[0].checked &&
            !this.state.fields.radio_customer_pep_past.options[1].checked)
        {
            return false;
        }


        if (this.state.fields.radio_customer_pep.options[1].checked &&
            this.state.fields.radio_customer_pep_details.index === -1)
        {
            return false;
        }


        if (this.state.fields.radio_customer_pep_past.options[1].checked &&
            this.state.fields.radio_customer_pep_past_details.index === -1)
        {
            return false;
        }



        return true;
    }
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/PepQuestions/PepQuestions.js